// extracted by mini-css-extract-plugin
export default {"list":"line-items_list__WdAvR","box":"line-items_box__7OtxK","key":"line-items_key__FQ1Lp","value":"line-items_value__UHk+J"};